import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box id="contact" className="no-print" display="flex" flexDirection="column" alignItems="center" mt={8}>
      <Typography variant="h5">Interested in Authenticators, Inc?</Typography>
      <Typography variant="body1">Contact Us</Typography>
      <Typography variant="body2">
        <a href="mailto:info@authenticatorsinc.com">info@authenticatorsinc.com</a>
      </Typography>
      <Typography variant="body2">© {currentYear} Authenticators, Inc. All rights reserved</Typography>
    </Box>
  );
};

export default Footer;
